export default __webpack_public_path__ + "static/media/apple-tv.6286c077.png";